"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BUTTON_CLASS = "inline-flex justify-center items-center gap-2 min-h-10 px-3 py-1 rounded-[2px] outline outline-1 outline-[#D4D3D0] border-none cursor-pointer font-sans font-semibold text-sm leading-[1.2] tracking-[0.64px] text-center focus-visible:ring-2 focus-visible:ring-[var(--primary)] disabled:opacity-60 disabled:cursor-not-allowed";
function SaveCancelFooter(_ref) {
  var onSave = _ref.onSave,
    onCancel = _ref.onCancel,
    isSaving = _ref.isSaving;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-row shrink-0 w-full gap-1 bg-white",
    "data-sentry-component": "SaveCancelFooter",
    "data-sentry-source-file": "SaveCancelFooter.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      onClick: onSave,
      disabled: isSaving,
      className: "".concat(BUTTON_CLASS, " flex-1 min-w-0 bg-primary text-white"),
      children: isSaving ? "Saving..." : "Save"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      onClick: onCancel,
      disabled: isSaving,
      className: "".concat(BUTTON_CLASS, " shrink-0 bg-[#F8F6F3] text-[#3D3D3D]"),
      children: "Cancel"
    })]
  });
}
var _default = exports.default = SaveCancelFooter;